import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const getApplicantPhone = (ct) =>
  ct.ggb ? ct.telephone || '' : ct.contact_phone || ct.telephone || '';

export const transContent = (content, ct) => {
  let data = dayjs().format('YYYY年M月D日');
  if (ct.pay_time && ct.pay_time != '0001-01-01 00:00:00') {
    if (ct.time_type) {
      data = dayjs(ct.kbdate).format('YYYY年M月D日');
    } else {
      data = dayjs(ct.pay_time).format('YYYY年M月D日');
    }
  }
  const money = ct.money.toFixed(2) + '元';
  content = content.replace(/{{编号}}/g, ct.code ? ct.code : '88888888888');
  content = content.replace(/{{担保费}}/g, ct.poundage.toString());
  content = content.replace(/{{担保费大写}}/g, convertCurrency(ct.poundage));
  content = content.replace(/{{担保额度}}/g, money);
  content = content.replace(/{{担保额度大写}}/g, convertCurrency(ct.money));
  content = content.replace(/{{出单日期}}/g, data);
  content = content.replace(/{{受益人}}/g, ct.proprietor);
  content = content.replace(/{{受益人统一社会信用代码}}/g, ct.proprietor_code ? ct.proprietor_code : '88888888888888888');
  content = content.replace(/{{受益人地址}}/g, ct.proprietor_address ? ct.proprietor_address : 'xxxxxxxxxxxxxxxx');
  content = content.replace(/{{受益人联系电话}}/g, ct.proprietor_connect_phone ? ct.proprietor_connect_phone : '11111111111');
  content = content.replace(/{{申请人}}/g, ct.bidder ? ct.bidder : 'XXXXXXXXXXXXXX有限公司');
  content = content.replace(/{{申请人法人}}/g, ct.legal_person ? ct.legal_person : '');
  content = content.replace(/{{申请人统一社会信用代码}}/g, ct.taxNumber ? ct.taxNumber : '88888888888888888');
  content = content.replace(/{{申请人地址}}/g, ct.companyAddress ? ct.companyAddress : 'xxxxxxxxxxxxxxxx');
  content = content.replace(/{{申请人联系电话}}/g, getApplicantPhone(ct));
  content = content.replace(/{{项目}}/g, ct.project);
  content = content.replace(/{{项目编号}}/g, ct.record_no);
  content = content.replace(/{{开户行}}/g, ct.company ? ct.company.bankName : 'XXXXXXXX银行');
  content = content.replace(/{{银行账号}}/g, ct.company ? ct.company.bankAccount : '8888888888');
  content = content.replace(/{{投标日期}}/g, ct.bidder_date);
  content = content.replace(/{{保函有效开始日期}}/g, data);
  if (ct.bulletinpubdate) {
    content = content.replace(/{{公告日期}}/g, ct.bulletinpubdate.split(' ')[0]);
  }
  if (ct.time_type) {
    if (ct.kbdate && ct.kbdate.indexOf('0001-01-01') == -1) {
      content = content.replace(
        /{{保函有效截止日期}}/g,
        dayjs(ct.kbdate).add(ct.effect_month, 'month').format('YYYY年M月D日'),
      );
    } else {
      content = content.replace(
        /{{保函有效截止日期}}/g,
        dayjs().add(ct.effect_month, 'month').format('YYYY年M月D日'),
      );
    }
  } else {
    if (ct.pay_time && ct.pay_time.indexOf('0001-01-01') == -1) {
      content = content.replace(
        /{{保函有效截止日期}}/g,
        dayjs(ct.pay_time).add(ct.effect_month, 'month').format('YYYY年M月D日'),
      );
    } else {
      content = content.replace(
        /{{保函有效截止日期}}/g,
        dayjs().add(ct.effect_month, 'month').format('YYYY年M月D日'),
      );
    }
  }

  const data2 = dayjs(ct.bidder_date, ['YYYY年M月D日', 'YYYY年MM月DD日']).format('YYYY年M月D日');
  if (ct.contract_d && ct.contract_d.length > 0) {
    for (const i of ct.contract_d) {
      if (i.name != '保函有效期') {
        const value = i.value.replace(/\n/g, '<br/>');
        content = content.replaceAll('{{' + i.name + '}}', value);
      }
    }
    for (const i of ct.contract_d) {
      if (i.name == '保函有效期') {
        content = content.replaceAll('{{' + i.name + '}}', data2);
      }
    }
  }
  content = content.replace(/{{.*}}/g, '      ');
  return content;
};
export const transContentO = (content, ct) => {
  let data = dayjs().format('YYYY年M月D日');
  let datasign = dayjs().format('YYYY年M月D日 HH时mm分ss秒');
  if (ct.sign_time && ct.sign_time.indexOf('0001-01-01') == -1) {
    datasign = dayjs(ct.sign_time).format('YYYY年M月D日 HH时mm分ss秒');
  }
  if (ct.sign_time && ct.sign_time.indexOf('0001-01-01') == -1) {
    data = dayjs(ct.sign_time).format('YYYY年M月D日');
  }
  const paydata = dayjs().format('YYYY年M月D日');
  const money = ct.money.toFixed(2) + '元';
  content = content.replace(/{{编号}}/g, '');
  content = content.replace(/{{担保费}}/g, ct.poundage.toString());
  content = content.replace(/{{担保费大写}}/g, convertCurrency(ct.poundage));
  content = content.replace(/{{担保额度}}/g, money);
  content = content.replace(/{{担保额度大写}}/g, convertCurrency(ct.money));
  content = content.replace(/{{出单日期}}/g, data);
  content = content.replace(/{{申请人}}/g, ct.bidder ? ct.bidder : '');
  content = content.replace(/{{申请人法人}}/g, ct.legal_person ? ct.legal_person : '');
  content = content.replace(/{{申请人统一社会信用代码}}/g, ct.taxNumber);
  content = content.replace(/{{申请人地址}}/g, ct.companyAddress ? ct.companyAddress : '');
  content = content.replace(/{{申请人联系电话}}/g, getApplicantPhone(ct));
  content = content.replace(/{{开户行}}/g, ct.company ? ct.company.bankName : '');
  content = content.replace(/{{银行账号}}/g, ct.company ? ct.company.bankAccount : '');
  // if (ct.category_id == 2) {
  //   content = content.replace(/{{业主}}/g, ct.proprietor);
  //   content = content.replace(/{{业主地址}}/g, ct.proprietor_address);
  // } else {
  //   content = content.replace(/{{业主}}/g, ct.landlord);
  //   content = content.replace(/{{业主地址}}/g, ct.landlord_address);
  // }
  content = content.replace(/{{业主}}/g, ct.proprietor);
  content = content.replace(/{{业主地址}}/g, ct.proprietor_address);
  content = content.replace(/{{受益人}}/g, ct.proprietor);
  content = content.replace(/{{受益人统一社会信用代码}}/g, ct.proprietor_code);
  content = content.replace(/{{受益人地址}}/g, ct.proprietor_address);
  content = content.replace(/{{受益人联系电话}}/g, ct.proprietor_connect_phone);
  content = content.replace(/{{项目}}/g, ct.project);
  content = content.replace(/{{保函有效开始日期}}/g, data);
  content = content.replace(/{{担保费率}}/g, ct.rate.toString());
  content = content.replace(
    /{{最低担保费}}/g,
    ct.lowest_poundage ? ct.lowest_poundage.toString() : '',
  );
  content = content.replace(/{{缴费提示日期}}/g, paydata);
  content = content.replace(/{{出函日期}}/g, datasign);
  if (ct.sign_time && ct.sign_time.indexOf('0001-01-01') == -1) {
    content = content.replace(
      /{{保函有效截止日期}}/g,
      dayjs(ct.sign_time).add(ct.effect_month, 'month').format('YYYY年M月D日'),
    );
  } else {
    content = content.replace(
      /{{保函有效截止日期}}/g,
      dayjs().add(ct.effect_month, 'month').format('YYYY年M月D日'),
    );
  }

  const data2 = dayjs(ct.bidder_date, ['YYYY年M月D日', 'YYYY年MM月DD日']).format('YYYY年M月D日');
  if (ct.contract_d && ct.contract_d.length > 0) {
    for (const i of ct.contract_d) {
      if (i.name != '保函有效期') {
        const value = i.value.replace(/\n/g, '<br/>');
        content = content.replaceAll('{{' + i.name + '}}', value);
      }
    }
    for (const i of ct.contract_d) {
      if (i.name == '保函有效期') {
        content = content.replaceAll('{{' + i.name + '}}', data2);
      }
    }
  }
  content = content.replace(/{{.*}}/g, '      ');
  return content;
};
export const transContentNoday = (content, ct) => {
  const money = ct.money.toFixed(2) + '元';
  let data = dayjs().format('YYYY年M月D日');
  if (ct.time_type) {
    data = ct.kbdate;
  }
  content = content.replace(/{{编号}}/g, ct.code ? ct.code : '88888888888');
  content = content.replace(/{{担保费}}/g, ct.poundage.toString());
  content = content.replace(/{{担保费大写}}/g, convertCurrency(ct.poundage));
  content = content.replace(/{{担保额度}}/g, money);
  content = content.replace(/{{担保额度大写}}/g, convertCurrency(ct.money));
  content = content.replace(/{{出单日期}}/g, data);
  content = content.replace(/{{受益人}}/g, ct.proprietor);
  content = content.replace(/{{受益人统一社会信用代码}}/g, ct.proprietor_code ? ct.proprietor_code : '88888888888888888');
  content = content.replace(/{{受益人地址}}/g, ct.proprietor_address ? ct.proprietor_address : 'xxxxxxxxxxxxxxxx');
  content = content.replace(/{{受益人联系电话}}/g, ct.proprietor_connect_phone ? ct.proprietor_connect_phone : '11111111111');
  content = content.replace(/{{申请人}}/g, ct.bidder ? ct.bidder : 'XXXXXXXXXXXXXX有限公司');
  content = content.replace(/{{申请人法人}}/g, ct.legal_person ? ct.legal_person : '');
  content = content.replace(/{{申请人统一社会信用代码}}/g, ct.taxNumber ? ct.taxNumber : '88888888888888888');
  content = content.replace(/{{申请人地址}}/g, ct.companyAddress ? ct.companyAddress : 'xxxxxxxxxxxxxxxx');
  content = content.replace(/{{申请人联系电话}}/g, getApplicantPhone(ct));
  content = content.replace(/{{项目}}/g, ct.project);
  content = content.replace(/{{项目编号}}/g, ct.record_no);
  content = content.replace(/{{开户行}}/g, ct.company ? ct.company.bankName : 'XXXXXXXX银行');
  content = content.replace(/{{银行账号}}/g, ct.company ? ct.company.bankAccount : '8888888888');
  content = content.replace(/{{投标日期}}/g, ct.bidder_date);
  content = content.replace(/{{保函有效开始日期}}/g, data);
  if (ct.bulletinpubdate) {
    content = content.replace(/{{公告日期}}/g, ct.bulletinpubdate.split(' ')[0]);
  }
  if (ct.time_type) {
    if (ct.kbdate && ct.kbdate.indexOf('0001-01-01') == -1) {
      content = content.replace(
        /{{保函有效截止日期}}/g,
        dayjs(ct.kbdate).add(ct.effect_month, 'month').format('YYYY年M月D日'),
      );
    }
  }
  content = content.replace(
    /{{保函有效截止日期}}/g,
    dayjs().add(ct.effect_month, 'month').format('YYYY年M月D日'),
  );
  const data2 = dayjs(ct.bidder_date, ['YYYY年M月D日', 'YYYY年MM月DD日']).format('YYYY年M月D日');
  if (ct.contract_d && ct.contract_d.length > 0) {
    for (const i of ct.contract_d) {
      if (i.name != '保函有效期') {
        const value = i.value.replace(/\n/g, '<br/>');
        content = content.replaceAll('{{' + i.name + '}}', value);
      }
    }
    for (const i of ct.contract_d) {
      if (i.name == '保函有效期') {
        content = content.replaceAll('{{' + i.name + '}}', data2);
      }
    }
  }

  return content;
};
export const transContentApply = (content, ct) => {
  const money = ct.money.toFixed(2) + '元';
  let data = dayjs().format('YYYY年M月D日');
  if (ct.time_type) {
    data = ct.kbdate;
  }
  content = content.replace(/{{编号}}/g, ct.code ? ct.code : '88888888888');
  content = content.replace(/{{担保费}}/g, ct.poundage.toString());
  content = content.replace(/{{担保费大写}}/g, convertCurrency(ct.poundage));
  content = content.replace(/{{担保额度}}/g, money);
  content = content.replace(/{{担保额度大写}}/g, convertCurrency(ct.money));
  content = content.replace(/{{出单日期}}/g, data);
  content = content.replace(/{{受益人}}/g, ct.proprietor);
  content = content.replace(/{{受益人统一社会信用代码}}/g, ct.proprietor_code ? ct.proprietor_code : '88888888888888888');
  content = content.replace(/{{受益人地址}}/g, ct.proprietor_address ? ct.proprietor_address : 'xxxxxxxxxxxxxxxx');
  content = content.replace(/{{受益人联系电话}}/g, ct.proprietor_connect_phone ? ct.proprietor_connect_phone : '11111111111');
  content = content.replace(/{{申请人}}/g, ct.company ? ct.company.owner : 'XXXXXXXXXXXXXX有限公司');
  content = content.replace(/{{申请人法人}}/g, ct.legal_person ? ct.legal_person : '');
  content = content.replace(/{{申请人统一社会信用代码}}/g, ct.company ? ct.company.taxNumber : '88888888888888888');
  content = content.replace(/{{申请人地址}}/g, ct.company ? ct.company.address : 'xxxxxxxxxxxxxxxx');
  content = content.replace(/{{申请人联系电话}}/g, ct.company ? ct.company.tel : '11111111111');
  content = content.replace(/{{项目}}/g, ct.project);
  content = content.replace(/{{项目编号}}/g, ct.record_no);
  content = content.replace(/{{开户行}}/g, ct.company ? ct.company.bankName : 'XXXXXXXX银行');
  content = content.replace(/{{银行账号}}/g, ct.company ? ct.company.bankAccount : '8888888888');
  content = content.replace(/{{投标日期}}/g, ct.bidder_date);
  content = content.replace(/{{保函有效开始日期}}/g, data);
  if (ct.bulletinpubdate) {
    content = content.replace(/{{公告日期}}/g, ct.bulletinpubdate.split(' ')[0]);
  }
  if (ct.time_type) {
    if (ct.kbdate && ct.kbdate.indexOf('0001-01-01') == -1) {
      content = content.replace(
        /{{保函有效截止日期}}/g,
        dayjs(ct.kbdate).add(ct.effect_month, 'month').format('YYYY年M月D日'),
      );
    }
  }
  content = content.replace(
    /{{保函有效截止日期}}/g,
    dayjs().add(ct.effect_month, 'month').format('YYYY年M月D日'),
  );
  const data2 = dayjs(ct.bidder_time, ['YYYY年M月D日', 'YYYY年MM月DD日']).format('YYYY年M月D日');
  if (ct.project_d && ct.project_d.length > 0) {
    for (const i of ct.project_d) {
      if (i.name != '保函有效期') {
        const value = i.value.replace(/\n/g, '<br/>');
        content = content.replaceAll('{{' + i.name + '}}', value);
      }
    }
    for (const i of ct.project_d) {
      if (i.name == '保函有效期') {
        content = content.replaceAll('{{' + i.name + '}}', data2);
      }
    }
  }

  return content;
};
export const transContentP = (content, ct) => {
  const data = dayjs().format('YYYY年M月D日');
  const money = ct.money + '元';
  content = content.replace(/{{编号}}/g, '88888888888');
  content = content.replace(/{{担保费}}/g, '800');
  content = content.replace(/{{担保费大写}}/g, convertCurrency(800));
  content = content.replace(/{{担保额度}}/g, money);
  content = content.replace(/{{担保额度大写}}/g, convertCurrency(ct.money));
  content = content.replace(/{{出单日期}}/g, data);
  content = content.replace(/{{投标人\/承包人}}/g, 'XXXXXXXXXXXXXX有限企业');
  content = content.replace(/{{项目}}/g, ct.name);
  content = content.replace(/{{受益人}}/g, ct.proprietor);
  content = content.replace(/{{开户行}}/g, 'XXXXXXXX银行');
  content = content.replace(/{{银行账号}}/g, '8888888888');
  content = content.replace(/{{投标日期}}/g, ct.bidder_time);
  content = content.replace(/{{保函有效开始日期}}/g, data);
  content = content.replace(
    /{{保函有效截止日期}}/g,
    dayjs().subtract(1, 'day').add(1, 'year').format('YYYY年M月D日'),
  );
  content = content.replace(
    /{{保函有效截止日期\(天\)}}/g,
    dayjs()
      .subtract(1, 'day')
      .add(ct.temp ? ct.temp.effect_day : 0, 'day')
      .format('YYYY年M月D日'),
  );
  const data2 = dayjs(ct.bidder_time, ['YYYY年M月D日', 'YYYY年MM月DD日'])
    .subtract(1, 'day')
    .format('YYYY年M月D日');
  if (ct.project_d && ct.project_d.length > 0) {
    for (const i of ct.project_d) {
      if (i.name != '保函有效期') {
        const value = i.value.replace(/\n/g, '<br/>');
        content = content.replaceAll('{{' + i.name + '}}', value);
      }
    }
    for (const i of ct.project_d) {
      if (i.name == '保函有效期') {
        content = content.replaceAll('{{' + i.name + '}}', data2);
      }
    }
  }
  content = content.replace(/{{.*}}/g, '      ');
  return content;
};
export const transContentP2 = (content, ct, companyname, poundage) => {
  const data = dayjs().format('YYYY年M月D日');
  const money = ct.money + '元';
  content = content.replace(/{{项目编号}}/g, ct.record_no);
  content = content.replace(/{{担保费}}/g, poundage.toFixed(2));
  content = content.replace(/{{担保费大写}}/g, convertCurrency(poundage));
  content = content.replace(/{{担保额度}}/g, money);
  content = content.replace(/{{担保额度大写}}/g, convertCurrency(ct.money));
  content = content.replace(/{{出单日期}}/g, data);
  content = content.replace(/{{投标人\/承包人}}/g, companyname);
  content = content.replace(/{{项目}}/g, ct.name);
  content = content.replace(/{{受益人}}/g, ct.proprietor);
  content = content.replace(/{{开户行}}/g, 'XXXXXXXX银行');
  content = content.replace(/{{银行账号}}/g, '8888888888');
  content = content.replace(/{{投标日期}}/g, ct.bidder_time);
  content = content.replace(/{{保函有效开始日期}}/g, data);
  content = content.replace(
    /{{保函有效截止日期}}/g,
    dayjs().subtract(1, 'day').add(1, 'year').format('YYYY年M月D日'),
  );
  content = content.replace(
    /{{保函有效截止日期\(天\)}}/g,
    dayjs()
      .subtract(1, 'day')
      .add(ct.temp ? ct.temp.effect_day : 0, 'day')
      .format('YYYY年M月D日'),
  );
  const data2 = dayjs(ct.bidder_time, ['YYYY年M月D日', 'YYYY年MM月DD日'])
    .subtract(1, 'day')
    .format('YYYY年M月D日');
  if (ct.project_d && ct.project_d.length > 0) {
    for (const i of ct.project_d) {
      if (i.name != '保函有效期') {
        const value = i.value.replace(/\n/g, '<br/>');
        content = content.replaceAll('{{' + i.name + '}}', value);
      }
    }
    for (const i of ct.project_d) {
      if (i.name == '保函有效期') {
        content = content.replaceAll('{{' + i.name + '}}', data2);
      }
    }
  }
  content = content.replace(/{{.*}}/g, '      ');
  return content;
};

export const transContentLinHai = (content, ct) => {
  const data = dayjs().format('YYYY年M月D日');
  const money = ct.money || '' + '元';
  content = content.replace(/{{编号}}/g, ct.toubaono);
  content = content.replace(/{{担保费}}/g, ct.poundage ? ct.poundage.toFixed(2) : '');
  content = content.replace(
    /{{担保费大写}}/g,
    convertCurrency(ct.poundage ? ct.poundage.toFixed(2) : ''),
  );
  content = content.replace(/{{担保额度}}/g, money);
  content = content.replace(
    /{{担保额度大写}}/g,
    convertCurrency(ct.money ? ct.money.toFixed(2) : ''),
  );
  content = content.replace(/{{出单日期}}/g, data);
  content = content.replace(/{{投标人\/承包人}}/g, ct.bidder);
  content = content.replace(/{{项目}}/g, ct.project);
  content = content.replace(/{{受益人}}/g, ct.proprietor);
  content = content.replace(/{{.*}}/g, '      ');
  return content;
};

export function convertCurrency(money) {
  //汉字的数字
  const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  //基本单位
  const cnIntRadice = ['', '拾', '佰', '仟'];
  //对应整数部分扩展单位
  const cnIntUnits = ['', '万', '亿', '兆'];
  //对应小数部分单位
  const cnDecUnits = ['角', '分', '毫', '厘'];
  //整数金额时后面跟的字符
  const cnInteger = '';
  //整型完以后的单位
  const cnIntLast = '';
  //最大处理的数字
  const maxNum = 999999999999.9999;
  //金额整数部分
  let integerNum;
  //金额小数部分
  let decimalNum;
  //输出的中文金额字符串
  let chineseStr = '';
  //分离金额后用的数组，预定义
  let parts;
  if (money == '') {
    return '';
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0;
    const IntLen = integerNum.length;
    for (let i = 0; i < IntLen; i++) {
      const n = integerNum.substr(i, 1);
      const p = IntLen - i - 1;
      const q = p / 4;
      const m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast + '元';
  }
  //小数部分
  if (decimalNum != '') {
    const decLen = decimalNum.length;
    for (let i = 0; i < decLen; i++) {
      const n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      } else if (n == '0') {
        chineseStr += cnNums[Number(n)];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger + '整';
  }
  return chineseStr;
}
